<template>
  <Modal title="Title" v-model="showFormModal" class-name="card-modal" :width="action=='view'?400:900">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>
    <Spin size="large" fix v-if="spinnerShow"></Spin>
    <Form ref="companyForm" :model="companyForm" :rules="ruleValidate" label-position="top">
      <Row class="widget-container">
        <i-col :xs="2" :sm="2" :md="2" :lg="2">
          <FormItem label="Deleted" :prop="'deleted'">
            <i-switch v-model="companyForm.deleted" @on-change="deletedCompany"></i-switch>
          </FormItem>
        </i-col>
        <i-col :xs="10" :sm="10" :md="10" :lg="10">
          <FormItem label="Company Name" :prop="'companyName'"
                    :rules="{required: true, message: 'Company Name cannot be empty', trigger: 'blur'}">
            <Input v-model="companyForm.companyName"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="6" :sm="6" :md="6" :lg="6">
          <FormItem label="Phone" :prop="'phone'"
                    :rules="{required: true, message: 'Phone cannot be empty', trigger: 'blur'}">
            <Input v-model="companyForm.phone"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="6" :sm="6" :md="6" :lg="6">
          <FormItem label="Email" :prop="'email'"
                    :rules="[{required: true, message: 'Email cannot be empty', trigger: 'blur'},
                      {type: 'string', min: 3, message: 'Description no less than 3 words', trigger: 'blur'}]">
            <Input v-model="companyForm.email"></Input>
          </FormItem>
        </i-col>

        <i-col :xs="12" :sm="12" :md="12" :lg="12">
          <FormItem label="Address" :prop="'address'">
            <Input v-model="companyForm.address"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="6" :sm="6" :md="6" :lg="6">
          <FormItem label="City" :prop="'city'"
                    :rules="{required: true, message: 'City be empty', trigger: 'blur'}">
            <Input v-model="companyForm.city"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="6" :sm="6" :md="6" :lg="6">
          <FormItem label="Country" :prop="'country'"
                    :rules="{required: true, message: 'Country cannot be empty', trigger: 'change'}">
            <Select v-model="companyForm.country" filterable clearable>
              <Option v-for="item in countries" :value="item.name" :key="item.name">
                {{item.name.trim()}}
              </Option>
            </Select>
          </FormItem>
        </i-col>

        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Select Events" :prop="'eventIds'">
            <Select v-model="eventList" multiple filterable>
              <Option v-for="item in getEventList" :value="item.eventId" :key="item.eventId">
                {{item.eventName}}
              </Option>
            </Select>
          </FormItem>
        </i-col>

        <Form enctype = "multipart/form-data">
          <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24">
            <i-col :xs = "4" :sm = "4" :md = "4" :lg = "4">
              <FormItem :prop = "'logoImage'">
                <label v-show = "isLogoImage">Logo Image</label>
                <label v-show = "!isLogoImage">Logo URL</label>
                <br>
                <i-switch v-model = "isLogoImage" id = "logoSwitch" @on-change = "resetLogoPreview"></i-switch>
              </FormItem>
            </i-col>
            <i-col :xs = "20" :sm = "20" :md = "20" :lg = "20">
              <FormItem :prop = "'logoUrl'">
                <input accept="image/*" name = "file" v-show = "isLogoImage" type = "file" id = "logoFile" ref = "logoFile"
                       v-on:change = "logoChange($event.target.files)" />
                <Input v-show = "!isLogoImage" v-model = "companyForm.logoUrl"
                       @on-change = "displayLogo($event.target.value); fileImg = null;" />
                <br>
                <table class = "logoBox">
                  <tr>
                    <td align = "center" style="max-width: 300px;max-height: 200px;">
                      <div class = "logo_preview_cont"></div>
                    </td>
                  </tr>
                </table>
              </FormItem>
            </i-col>
          </i-col>
        </Form>

      </Row>
    </Form>
    <div slot="footer" id="dvFooter">
      <Button size="large" @click="handleReset;showFormModal=false" style="margin-left: 8px">
        Cancel
      </Button>
      <Button size="large" class="submit" type="success" @click="handleCreate('companyForm')"
              v-if="action=='add'">
        Create
      </Button>
      <Button size="large" class="submit" type="success" v-if="action=='edit'"
              @click="handleUpdate('companyForm', companyForm.companyId)">
        Save
      </Button>
    </div>
  </Modal>
</template>

<script>
  import {addCompany, updateCompany, uploadLogo} from '../../services/Companies.service'
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../../main'
  import {countries} from '../../services/countries'

  export default {
    components: {},
    data() {
      return {
        logoImg: null,
        fileImg: new FormData(),
        licenseItems: null,
        eventList: null,
        result: null,
        index: 0,
        countries: countries,
        action: 'Add',
        title: 'ADD Event',
        showFormModal: false,
        companyForm: {
          companyId: null,
          languageId: null,
          companyName: null,
          phone: null,
          email: null,
          address: null,
          city: null,
          country: null,
          logoUrl: null,
          logoImage: null,
          createdBy: null,
          createdDate: null,
          deleted: false,
          deletionDate: null,
          updatedBy: null,
          updatedDate: null,
          userIds: null,
          formIds: null,
          leadIds: null,
          licenseIds: null,
          eventIds: null
        },
        indeterminate: null,
        checkAll: false,
        ruleValidate: {},
        spinnerShow: true,
        companyConfirmDelete: false,
        companyDeleteMessage: '',
        companyDeleteIndex: null,
        file: null,
        oldLogoUrl: null,
        isLogoImage: false
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      logoChange(fileList) {
        const self = this;
        if (fileList.length === 0) {
          self.companyForm.logoUrl = self.oldLogoImage;
          self.fileImg = null;
          document.getElementsByClassName('logo_preview_cont')[0].innerHTML = "";
          return;
        }
        self.fileImg = new FormData();
        self.fileImg.append(fileList[0].name, fileList[0], 'CompanyLogo');
        var reader = new FileReader(),
          files = fileList[0];

        reader.onload = function (e) {
          self.displayLogo(e.target.result);
        }
        reader.readAsDataURL(files);
      },

      resetLogoPreview(val) {
        this.isLogoImage = val;
        if (this.isLogoImage) {
          document.getElementsByClassName('logo_preview_cont')[0].innerHTML = "";
        } else {
          if (this.companyForm.logoUrl) {
            this.displayLogo(this.companyForm.logoUrl);
          }
        }
      },

      displayLogo(image) {
        var img = new Image();
        var container = document.getElementsByClassName('logo_preview_cont')[0];
        if (!container) return;
        container.innerHTML = "";
        img.id = 'logo_preview' + container.getElementsByTagName('img').length;
        img.src = image;
        img.style.height = '100%';
        img.style.width = '100%';
        container.appendChild(img);
      },

      openCompanyForm(title, action) {
        this.handleReset();
        this.showFormModal = true;
        this.title = title;
        this.action = action;
        this.eventList = [];
        this.spinnerShow = false;
        this.isLogoImage = false;
        this.companyForm.deleted = false;
        this.companyForm.country = 'France';
      },
      setFormValue(params, index) {
        let data = Object.assign({}, params);
        delete data['_index'];
        delete data['_rowKey'];
        const self = this;
        if (data.eventIds) {
          data.eventIds.forEach(function (id) {
            let event = JSON.parse(localStorage.getItem('events')).filter(a => a.eventId == id)[0];
            if (event) {
              self.eventList.push(event.eventId);
            }
          })
        }

        self.companyForm = data;
        self.oldLogoImage = self.companyForm.logoUrl;
        self.fileImg = null;

        if (self.companyForm.logoUrl) {
          self.displayLogo(self.companyForm.logoUrl);
        } else {
          document.getElementsByClassName('logo_preview_cont')[0].innerHTML = "";
        }

        if (this.action == 'add') {
          self.companyForm.country = 'France';
        }
      },
      handleCreate(name) {
        const self = this;
        this.$refs['companyForm'].validate((validate) => {
          let valid = self.validateForm(validate);
          if (valid) {
            const data = Object.assign({}, self.companyForm);
            self.spinnerShow = true;
            data['companyId'] = 0;
            data['companyName'] = data.companyName;
            data['languageId'] = data.languageId;
            data['phone'] = data.phone;
            data['email'] = data.email;
            data['address'] = data.address;
            data['city'] = data.city;
            data['country'] = data.country;
            data['logoUrl'] = data.logoUrl;
            data['logoImage'] = data.logoImage;
            data['createdBy'] = data.createdBy;
            data['createdDate'] = data.createdDate;
            data['deleted'] = data.deleted;
            data['deletionDate'] = data.deletionDate;
            data['updatedBy'] = data.updatedBy;
            data['updatedDate'] = data.updatedDate;
            data['userIds'] = data.userIds;
            data['leadIds'] = data.leadIds;
            data['formIds'] = data.formIds;
            data['licenseIds'] = data.licenseIds;
            data['eventIds'] = this.eventList;

            addCompany(data)
              .then(response => {

                if (self.fileImg != null) {
                  uploadLogo(response.data.companyId, self.fileImg).then(dataResponse => {
                    data.companyId = response.data.companyId;
                    data.logoUrl = dataResponse.data;

                    updateCompany(response.data.companyId, data).then(res => {
                      data['companyId'] = response.data.companyId;
                      self.$emit('addCompany', data);
                      self.$Message.success('Company successfully added!');
                      bus.$emit('changeForm', localStorage.getItem('selected_event'));
                      bus.$emit('reloadAdminData');
                      bus.$emit('GetCompaniesEvents');
                      self.showFormModal = false;
                      self.spinnerShow = false;
                    }).catch(error => {
                      self.spinnerShow = false;
                      self.$Message.error('Failed updating Company Logo');
                    })
                  }).catch(error => {
                    this.$Message.error('Failed uploading logo');
                  });
                } else {
                  data['companyId'] = response.data.companyId;
                  self.$emit('addCompany', data);
                  self.$Message.success('Company successfully added!');
                  bus.$emit('changeForm', localStorage.getItem('selected_event'));
                  bus.$emit('reloadAdminData');
                  bus.$emit('GetCompaniesEvents');
                  self.showFormModal = false;
                  self.spinnerShow = false;
                }
              }).catch(error => {
                if (error.response.request.responseText) {
                  let errResponse = JSON.parse(error.response.request.responseText);
                  Object.keys(errResponse).map(key => {
                    errResponse[key].map(errMsg => {
                      self.$Message.error(errMsg);
                    })
                  })
                } else {
                  self.$Message.error('Failed updating Company ' + error);
                }
                self.spinnerShow = false;
              })
          }
        })
      },
      handleUpdate(name, id) {
        const self = this;
        if (!self.fileImg && !self.companyForm.logoUrl) {
          self.companyForm.logoUrl = self.oldLogoUrl;
        }
        const validateEmail = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Email must have value'));
          } else {
            if (self.companyForm.email !== '') {
              self.$refs.companyForm.validateField('email');
            }
            callback();
          }
        };
        self.$refs['companyForm'].validate((validate) => {
          let valid = self.validateForm(validate);
          if (valid) {
            uploadLogo(id, self.fileImg).then(response => {
              if (response.data != "") {
                self.companyForm.logoUrl = response.data;
              }

            self.spinnerShow = true;
            const data = Object.assign({}, self.companyForm);
            data['eventIds'] = self.eventList;
            updateCompany(id, data)
              .then(response => {
                self.$emit('updateCompany', id, data);
                self.$Message.success('Company successfully updated!');
                bus.$emit('changeForm', localStorage.getItem('selected_event'));
                self.showFormModal = false;
                bus.$emit('reloadAdminData');
                bus.$emit('GetCompaniesEvents');
                self.spinnerShow = false;
              })
              .catch(error => {
                if (error.response.request.responseText) {
                  let errResponse = JSON.parse(error.response.request.responseText)
                  Object.keys(errResponse).map(key => {
                    errResponse[key].map(errMsg => {
                      self.$Message.error(errMsg);
                    })
                  })
                } else {
                  self.$Message.error('Failed updating Company ' + error);
                  console.log(error);
                }
                self.spinnerShow = false;
              });
            }).catch(error => {
              this.$Message.error('Failed uploading logo');
            });
          }
        })
      },
      handleReset() {
        this.$refs['companyForm'].resetFields();
        let self = this;
        Object.keys(this.companyForm).forEach(function (key, i) {
          self.companyForm[key] = null;
        });
        document.getElementById('logoFile').value = "";
        self.isLogoImage = false;
        self.fileImg = null;
        document.getElementsByClassName('logo_preview_cont')[0].innerHTML = "";
      },
      validateForm() {
        //email
        let re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.$refs.companyForm.validateField('email', function (e) {
        });

        let validEmail = re.test(this.companyForm.email.toLowerCase());
        if (!validEmail) {
          this.$Message.error('Email is invalid');
        }

        //phone
        let validPhone = this.companyForm.phone.length >= 10;
        if (!validPhone) {
          this.$Message.error('Phone is invalid');
        }

        let valid = validEmail && validPhone;
        return valid;
      },
      deletedCompany(val) {
        this.companyForm.deleted = val;
      }
    }
  }
</script>

<style scoped>
  .logoBox {
    display: block;
    width: 100%;
    border: 0.5px dashed #000;
    border-radius: 5px;
  }

  .full-input {
    display: inline-block;
    width: 100%;
    padding: 3px;
    border: 1px solid #f8f8f9;
    border-radius: 4px;
    width: 100%;
  }

  .input-answer {
    display: block;
    width: 100%;
    outline: none;
    border: none;
    line-height: 1.2em;
    font-size: 14pt;
  }

  .label-answer {
    text-align: left;
    display: block;
    font: normal 12px italic;
    color: #000;
    opacity: 0.5
  }

  #dvFooter {
    text-align: center;
  }


  .greenBox {
    font-size: 20px;
    font-weight: 900;
    color: #fff;
    background-color: #35bc44;
    border-radius: 5px;
  }

  .grayBox {
    font-size: 20px;
    font-weight: 900;
    color: #fff;
    background-color: #6f6f70;
    border-radius: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/k_globalAdministration/companyForm.vue